/* JAPANIME.IT — Phase 72: live essential filters with stable mobile disclosure and viewport. */
(() => {
  const filtersSelector = '[data-jp-essential-filters]';
  const mobileToggleSelector = '[data-jp-essential-filters-mobile-toggle]';
  const expandToggleSelector = '[data-jp-essential-filters-toggle]';
  const filterLinkSelector = '.jp-quick-filters__chip, [data-jp-filter-clear]';
  const expandedStorageKey = `jp-essential-filters-expanded:${window.location.pathname}`;
  let pendingViewportPosition = null;

  const announceUpdate = (phase) => {
    document.dispatchEvent(new CustomEvent(`japanime:filters-update-${phase}`));
  };

  const readStoredBoolean = (key) => {
    try {
      return window.sessionStorage.getItem(key) === 'true';
    } catch (error) {
      return false;
    }
  };

  const storeBoolean = (key, value) => {
    try {
      window.sessionStorage.setItem(key, value ? 'true' : 'false');
    } catch (error) {
      // Storage is optional; the controls still work without persistence.
    }
  };

  const setMobileOpen = (open) => {
    const filters = document.querySelector(filtersSelector);
    const toggle = document.querySelector(mobileToggleSelector);
    if (!filters || !toggle) return;

    filters.classList.toggle('is-mobile-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? toggle.dataset.closeLabel : toggle.dataset.openLabel;
  };

  const setExpanded = (expanded) => {
    const filters = document.querySelector(filtersSelector);
    const toggle = filters?.querySelector(expandToggleSelector);
    if (!filters || !toggle) return;

    filters.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel;
    storeBoolean(expandedStorageKey, expanded);
  };

  const restoreDisclosureState = () => {
    const filters = document.querySelector(filtersSelector);
    setMobileOpen(filters?.dataset.jpHasActiveFilters === 'true');
    setExpanded(readStoredBoolean(expandedStorageKey));
  };

  const rememberViewportPosition = (control) => {
    if (!control) return;
    pendingViewportPosition = {
      top: control.getBoundingClientRect().top,
      scrollY: window.scrollY,
      kind: control.matches('[data-jp-essential-sort]')
        ? 'sort'
        : control.matches('[data-jp-filter-clear]')
          ? 'clear'
          : 'filter',
      param: control.dataset.jpFilterParam || '',
      value: control.dataset.jpFilterValue || '',
    };
  };

  const findUpdatedControl = ({ kind, param, value }) => {
    if (kind === 'sort') return document.querySelector('[data-jp-essential-sort]');
    if (kind === 'clear') return document.querySelector('[data-jp-filter-clear]');
    return [...document.querySelectorAll('.jp-quick-filters__chip')].find(
      (control) => control.dataset.jpFilterParam === param && control.dataset.jpFilterValue === value,
    );
  };

  const restoreViewportPosition = () => {
    if (!pendingViewportPosition) return;
    const position = pendingViewportPosition;
    pendingViewportPosition = null;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const updatedControl = findUpdatedControl(position);
        if (!updatedControl) {
          window.scrollTo({ top: position.scrollY, left: window.scrollX, behavior: 'auto' });
          return;
        }

        const offset = updatedControl.getBoundingClientRect().top - position.top;
        if (Math.abs(offset) > 0.5) window.scrollBy({ top: offset, left: 0, behavior: 'auto' });
      });
    });
  };

  const canRenderWithAjax = () =>
    Boolean(window.FacetFiltersForm) &&
    typeof window.FacetFiltersForm.renderPage === 'function' &&
    Boolean(document.getElementById('ProductGridContainer'));

  const samePagePath = (url) => {
    const normalize = (path) => path.replace(/\/+$/, '') || '/';
    return url.origin === window.location.origin && normalize(url.pathname) === normalize(window.location.pathname);
  };

  document.addEventListener('click', (event) => {
    const mobileToggle = event.target.closest(mobileToggleSelector);
    if (mobileToggle) {
      setMobileOpen(!document.querySelector(filtersSelector)?.classList.contains('is-mobile-open'));
      return;
    }

    const expandToggle = event.target.closest(expandToggleSelector);
    if (expandToggle) {
      setExpanded(!document.querySelector(filtersSelector)?.classList.contains('is-expanded'));
      return;
    }

    const link = event.target.closest(filterLinkSelector);
    if (!link || !link.closest(filtersSelector)) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const url = new URL(link.href, window.location.href);
    if (!canRenderWithAjax() || !samePagePath(url)) return;

    event.preventDefault();
    rememberViewportPosition(link);
    announceUpdate('start');
    window.FacetFiltersForm.renderPage(url.searchParams.toString(), { target: link });
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-jp-essential-sort]');
    if (!select) return;

    const form = select.closest('[data-jp-essential-sort-form]');
    if (!form) return;

    if (canRenderWithAjax()) {
      rememberViewportPosition(select);
      announceUpdate('start');
      const searchParams = new URLSearchParams(new FormData(form)).toString();
      window.FacetFiltersForm.renderPage(searchParams, { target: select });
      return;
    }

    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });

  document.addEventListener('japanime:collection-updated', () => {
    restoreDisclosureState();
    restoreViewportPosition();
    announceUpdate('end');
  });

  restoreDisclosureState();
})();
